import LocalStorageHelper from '@/helpers/LocalStorageHelper';

interface IEnumItem<E> {
  id: E;
  name: keyof E;
}

export default class AppHelper {
  public static deepClone<T>(object: T): T {
    return JSON.parse(JSON.stringify(object));
  }

  public static enumToArray<E>(enumToConvert: Record<string, unknown>): IEnumItem<E>[] {
    return Object.keys(enumToConvert).map(key => ({ id: enumToConvert[key], name: key } as IEnumItem<E>));
  }

  public static partnerShopLink(link: string): string {
    const partnerShopSubdomain = LocalStorageHelper.getPartnerShopInformation()?.subdomain;
    return link.replace(`partnersite`, partnerShopSubdomain ?? `www`);
  }

  public static redirectFromPPS(): void {
    const domain = document.location.href;
    document.location.href = `https://www${domain.substr(domain.indexOf(`.`))}`;
  }
}
